module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-header', [_c('h1', [_vm._v("Services")])]), _vm._v(" "), _c('main', {
    staticClass: "wrap",
    class: _vm.$style.services
  }, _vm._l((_vm.services), function(item) {
    return _c('article', {
      class: _vm.$style.item
    }, [_c('h2', {
      class: _vm.$style.title,
      domProps: {
        "innerHTML": _vm._s(item.title.rendered)
      }
    }), _vm._v(" "), _c('p', {
      class: _vm.$style.description
    }, [_vm._v(_vm._s(item.acf.description))])])
  }), 0), _vm._v(" "), (this.loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-99da7564!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Services.vue
// module id = 119
// module chunks = 2